import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { tID } from '../../utils'

type MiscellaneousIllustrationProps = {
  size?: string | number
  selected?: string
}

export const MiscellaneousIllustration: FunctionComponent<MiscellaneousIllustrationProps> = ({
  selected = false,
  size,
}) => (
  <Svg
    width={size}
    height={size}
    viewBox='0 0 48 48'
    fill='none'
    testID={tID(`somethingElse${selected ? '-Selected-' : '-'}Illustration`)}
  >
    <Path
      d='M14.1706 0H6.90191C3.09009 0 0 3.36257 0 7.5105V22.4108C0 26.5587 3.09009 29.9213 6.90191 29.9213H14.1706C17.9824 29.9213 21.0725 26.5587 21.0725 22.4108V7.5105C21.0725 3.36257 17.9824 0 14.1706 0Z'
      fill={selected ? '#3BA5B5' : '#FFC03C'}
    />
    <Path
      d='M42.0444 18.0779H32.8835C29.5942 18.0779 26.9277 20.9795 26.9277 24.5588V41.5182C26.9277 45.0975 29.5942 47.9992 32.8835 47.9992H42.0444C45.3337 47.9992 48.0002 45.0975 48.0002 41.5182V24.5588C48.0002 20.9795 45.3337 18.0779 42.0444 18.0779Z'
      fill={selected ? '#85CCD5' : '#E3D3C8'}
    />
    <Path
      d='M43.0175 0.624512H30.7398C28.6345 0.624512 26.9277 2.49746 26.9277 4.80787V9.53172C26.9277 11.8421 28.6345 13.7151 30.7398 13.7151H43.0175C45.1228 13.7151 46.8295 11.8421 46.8295 9.53172V4.80787C46.8295 2.49746 45.1228 0.624512 43.0175 0.624512Z'
      fill={selected ? '#3BA5B5' : '#85CCD5'}
    />
    <Path
      d='M16.6747 34.908H4.39702C2.29168 34.908 0.584961 36.7809 0.584961 39.0913V43.8152C0.584961 46.1256 2.29168 47.9985 4.39702 47.9985H16.6747C18.78 47.9985 20.4867 46.1256 20.4867 43.8152V39.0913C20.4867 36.7809 18.78 34.908 16.6747 34.908Z'
      fill={selected ? '#85CCD5' : '#FFB199'}
    />
  </Svg>
)
